import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class DataImportHelper  {
    _originalTypeClassName = "zERP.BO.DataImportHelper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
DataImportHelper.translate = translateService;
}
this.DataImportHelperKey = null;
this._key = this.DataImportHelperKey = 0; 
}

static translate: TranslateService;
_key: any;
private _DataImportHelperKey:any;
get DataImportHelperKey(): any {
    return this._DataImportHelperKey;
  }
set DataImportHelperKey(value: any) {
    this._DataImportHelperKey = value;
    this._key = value;
  }

static CleanUpCodeField(code: any): any{let cleanField = code?.trim();
if (Joove.Common.stringContains(cleanField, "\"")) {if (cleanField?.indexOf("\"") === 0 && Joove.Common.stringEndsWith(cleanField, "\"")) {cleanField = cleanField?.substr(1, Joove.Common.safeNumber(cleanField?.length) - Joove.Common.safeNumber(2))?.trim();}else {if (cleanField?.indexOf("\"") === 0) {cleanField = cleanField?.substr(1, Joove.Common.safeNumber(cleanField?.length) - Joove.Common.safeNumber(1))?.trim();}else if (Joove.Common.stringEndsWith(cleanField, "\"")) {cleanField = cleanField?.substr(0, Joove.Common.safeNumber(cleanField?.length) - Joove.Common.safeNumber(1))?.trim();}}}
return cleanField;
}
static ParseDate(date: any): any{try {let indexOfSpace = date?.indexOf(" ");if (CLMS.Framework.Number.GreaterThan(() => indexOfSpace, () => -1)) {date = date?.substr(0, indexOfSpace);}console.warn("parsgin date: " + date + " -> " + CLMS.Framework.DateTime.ParseExact(date, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "d/M/yyyy").toDate());return CLMS.Framework.DateTime.ParseExact(date, Joove.GlobalizationManager.GetCurrentLocaleManager().SortName, "d/M/yyyy").toDate();}
catch (e) {console.warn("Failed to parse date: " + date);}
return null;
}
static ParseDecimal(number: any): any{try {return CLMS.Framework.Decimal.Parse(number);}
catch (e) {console.warn("Failed to parse decimal: " + number);}
return 0;
}
static ParseDouble(number: any): any{try {return CLMS.Framework.Double.Parse(number);}
catch (e) {console.warn("Failed to parse double: " + number);}
return 0;
}
static ParseGreekBoolean(greekBool: any): any{if (CLMS.Framework.String.IsNullOrEmpty((greekBool ?? '').trim())) {return false;}
return greekBool == "ΝΑΙ" || greekBool == "Ν" || greekBool == "ναι" || greekBool == "ναί" || greekBool == "NAI";
}
static ParseInt(number: any): any{try {return CLMS.Framework.Integer.Parse(number);}
catch (e) {console.warn("Failed to parse int: " + number);}
return 0;
}
static ParseTime(time: any): any{try {let indexOfSpace = time?.indexOf(" ");if (CLMS.Framework.Number.GreaterThan(() => indexOfSpace, () => -1)) {time = time?.substr(0, indexOfSpace);}console.warn("parsgin time: " + time);let words = System.split(time, ':');let hours = null;let mins = null;let index = 0;for (let _iw = 0; _iw < (words == null ? 0 : words.length); _iw++) {let w = words[_iw];if (CLMS.Framework.Number.Equal(() => index, () => 0)) {hours = Domain.DataImportHelper.ParseInt(w);}if (CLMS.Framework.Number.Equal(() => index, () => 1)) {mins = Domain.DataImportHelper.ParseInt(w);}index = Joove.Common.safeNumber(index) + Joove.Common.safeNumber(1);}let dt = moment().toDate();let value = moment(dt).year()?.toString() + "/" + (moment(dt).month() + 1)?.toString() + "/" + moment(dt).date()?.toString() + " " + hours?.toString() + ":" + mins?.toString() + ":00";dt = moment(value).toDate();moment(dt).unix();return dt;}
catch (e) {console.warn("Failed to parse time: " + time);}
return null;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.DataImportHelperKey == null || $this.DataImportHelperKey == 0;
            }


}